export { PaymentsSection } from './PaymentsSection'
export type { PaymentsSectionProps } from './PaymentsSection'
